'use strict';

angular.module('ClinicApp').directive('userBusinessAgreements', function(CurrentUser) {
  return {
    restrict: 'A',
    templateUrl: '/views/directives/_user-business-agreements.html',
    link: function($scope) {
      loadUser();

      function loadUser() {
        return CurrentUser.waitForUserLoad(CurrentUser.getUser).then(function(user) {
          $scope.signedDocuments = _.sortBy($scope.user.signedDocuments, 'signedAt').reverse();
          // Ensures only the latest signed documents are displayed
          $scope.signedDocuments = _.uniq($scope.signedDocuments, 'type');
          $scope.signedDocuments = _.indexBy($scope.signedDocuments, 'type');
          $scope.user = user;
        });
      }

    },
  };
});
